export default "__VITE_ASSET__CUrAp2xK__"